import { getPatternStyles, patternFns } from '../helpers.mjs';
import { css } from '../css/index.mjs';

const styledContainerConfig = {
transform(props) {
  return {
    position: "relative",
    width: "[100%]",
    mx: "auto",
    maxWidth: "{breakpoints.lg}",
    display: "flex",
    flexDirection: "column",
    gap: "3",
    "--padding-x": {
      base: "{spacing.3}",
      sm: "[calc(2.75rem + 1.25 * (100vw - 27.5rem) / 54.5)]",
      lg: "{spacing.8}"
    },
    px: "var(--padding-x)",
    ...props
  };
}}

export const getStyledContainerStyle = (styles = {}) => {
  const _styles = getPatternStyles(styledContainerConfig, styles)
  return styledContainerConfig.transform(_styles, patternFns)
}

export const styledContainer = (styles) => css(getStyledContainerStyle(styles))
styledContainer.raw = getStyledContainerStyle